import './new-waiver.scss';

import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import HeaderContent from "@shared/ui/header-content/header-content";
import FormWaiver from "../form-waiver/form-waiver";
import { useNewWaiver } from './new-waiver.hook';

export function NewWaiver() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewWaiver();

  return (
    <div id="NewWaiver" className="waiver">
      <HeaderContent
        title="New Waiver"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormWaiver />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewWaiver;